import { EVENTO_INTERNO } from '@mymaxx/shared';
import { useEffect, useRef } from 'react';
import { useChamada } from './chamada.js';
export function useTelefoneInterno(socket, buscarServidores) {
    /**
     * O endereço do outro lado e a conversa da chamada.
     *
     * Em `ref` porque são endereço, não tela: mudam no meio da sinalização, e nada precisa
     * ser redesenhado por causa deles. O servidor é quem diz quem é o outro lado — numa
     * conversa direta, só ele sabe quem é o outro membro.
     */
    const outroLado = useRef(undefined);
    const canalDaChamada = useRef(undefined);
    const chamada = useChamada({
        sdp: (chamadaId, tipo, sdp) => socket?.emit(EVENTO_INTERNO.CHAMADA_SDP, {
            chamadaId,
            tipo,
            sdp,
            para: outroLado.current,
        }),
        rota: (chamadaId, candidato) => socket?.emit(EVENTO_INTERNO.CHAMADA_ROTA, {
            chamadaId,
            candidato,
            para: outroLado.current,
        }),
        atendida: (chamadaId) => socket?.emit(EVENTO_INTERNO.CHAMADA_ATENDIDA, { chamadaId, para: outroLado.current }),
        fim: (chamadaId, motivo) => socket?.emit(EVENTO_INTERNO.CHAMADA_FIM, {
            chamadaId,
            canalId: canalDaChamada.current,
            para: outroLado.current,
            motivo,
        }),
    }, buscarServidores);
    /**
     * A chamada atual, lida de uma `ref` pelos ouvintes.
     *
     * O motor devolve um objeto novo a cada render; amarrar os ouvintes a ele desinscreveria
     * e reinscreveria o socket sem parar, com chance de perder um sinal no meio da troca.
     */
    const atual = useRef(chamada);
    atual.current = chamada;
    useEffect(() => {
        if (!socket)
            return;
        const chamando = (e) => {
            outroLado.current = e.de;
            canalDaChamada.current = e.canalId;
            atual.current.aoReceberChamada({
                chamadaId: e.chamadaId,
                nome: e.nome,
                avatarUrl: e.avatarUrl,
            });
        };
        const sdp = (e) => {
            outroLado.current = e.de;
            void atual.current.aoReceberSdp(e.chamadaId, e.tipo, e.sdp);
        };
        const rota = (e) => void atual.current.aoReceberRota(e.chamadaId, e.candidato);
        const atendida = (e) => atual.current.aoSerAtendida(e.chamadaId);
        const fim = (e) => atual.current.aoReceberFim(e.chamadaId);
        const ouvintes = [
            [EVENTO_INTERNO.CHAMANDO, chamando],
            [EVENTO_INTERNO.CHAMADA_SDP, sdp],
            [EVENTO_INTERNO.CHAMADA_ROTA, rota],
            [EVENTO_INTERNO.CHAMADA_ATENDIDA, atendida],
            [EVENTO_INTERNO.CHAMADA_FIM, fim],
        ];
        for (const [evento, ouvinte] of ouvintes)
            socket.on(evento, ouvinte);
        return () => {
            for (const [evento, ouvinte] of ouvintes)
                socket.off(evento, ouvinte);
        };
    }, [socket]);
    return {
        ...chamada,
        podeLigar: !!socket,
        ligarPara: (canalId, nome) => {
            if (!socket)
                return;
            canalDaChamada.current = canalId;
            // O endereço do outro lado vem na resposta do servidor: sem ele, a oferta de mídia
            // não teria para onde ir.
            socket.emit(EVENTO_INTERNO.CHAMANDO, { canalId }, (resposta) => {
                if (!resposta?.chamadaId)
                    return;
                outroLado.current = resposta.para;
                void atual.current.ligar({ chamadaId: resposta.chamadaId, nome });
            });
        },
    };
}
//# sourceMappingURL=telefone.js.map